import { createAction } from "redux-actions";

export const ADD_NEW_PROPERTY = "ADD_NEW_PROPERTY";
export const addNewProperty = createAction(ADD_NEW_PROPERTY);

export const ADD_NEW_PROPERTY_REQUESTED = "ADD_NEW_PROPERTY_REQUESTED";
export const addNewPropertyRequested = createAction(ADD_NEW_PROPERTY_REQUESTED);

export const ADD_NEW_PROPERTY_FAILURE = "ADD_NEW_PROPERTY_FAILURE";
export const addNewPropertyFailure = createAction(ADD_NEW_PROPERTY_FAILURE);

export const ADD_NEW_PROPERTY_SUCCESS = "ADD_NEW_PROPERTY_SUCCESS";
export const addNewPropertySuccess = createAction(ADD_NEW_PROPERTY_SUCCESS);

export const UPDATE_SINGLE_PROPERTY = "UPDATE_SINGLE_PROPERTY";
export const updateSingleProperty = createAction(UPDATE_SINGLE_PROPERTY);

export const UPDATE_SINGLE_PROPERTY_REQUESTED = "UPDATE_SINGLE_PROPERTY_REQUESTED";
export const updateSinglePropertyRequested = createAction(UPDATE_SINGLE_PROPERTY_REQUESTED);

export const UPDATE_SINGLE_PROPERTY_FAILURE = "UPDATE_SINGLE_PROPERTY_FAILURE";
export const updateSinglePropertyFailure = createAction(UPDATE_SINGLE_PROPERTY_FAILURE);

export const UPDATE_SINGLE_PROPERTY_SUCCESS = "UPDATE_SINGLE_PROPERTY_SUCCESS";
export const updateSinglePropertySuccess = createAction(UPDATE_SINGLE_PROPERTY_SUCCESS);

export const FETCH_MY_PROPERTIES = "FETCH_MY_PROPERTIES";
export const fetchMyProperties = createAction(FETCH_MY_PROPERTIES);

export const FETCH_MY_PROPERTIES_REQUESTED = "FETCH_MY_PROPERTIES_REQUESTED";
export const fetchMyPropertiesRequested = createAction(FETCH_MY_PROPERTIES_REQUESTED);

export const FETCH_MY_PROPERTIES_FAILURE = "FETCH_MY_PROPERTIES_FAILURE";
export const fetchMyPropertiesFailure = createAction(FETCH_MY_PROPERTIES_FAILURE);

export const FETCH_MY_PROPERTIES_SUCCESS = "FETCH_MY_PROPERTIES_SUCCESS";
export const fetchMyPropertiesSuccess = createAction(FETCH_MY_PROPERTIES_SUCCESS);

export const FETCH_SINGLE_PROPERTY = "FETCH_SINGLE_PROPERTY";
export const fetchSingleProperty = createAction(FETCH_SINGLE_PROPERTY);

export const FETCH_SINGLE_PROPERTY_REQUESTED = "FETCH_SINGLE_PROPERTY_REQUESTED";
export const fetchSinglePropertyRequested = createAction(FETCH_SINGLE_PROPERTY_REQUESTED);

export const FETCH_SINGLE_PROPERTY_FAILURE = "FETCH_SINGLE_PROPERTY_FAILURE";
export const fetchSinglePropertyFailure = createAction(FETCH_SINGLE_PROPERTY_FAILURE);

export const FETCH_SINGLE_PROPERTY_SUCCESS = "FETCH_SINGLE_PROPERTY_SUCCESS";
export const fetchSinglePropertySuccess = createAction(FETCH_SINGLE_PROPERTY_SUCCESS);
